import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Calculator, Palette, MessageCircle } from 'lucide-react';
const bonuses = [{
  badge: 'TOP 1',
  title: 'Calculadora Automática de Ganancias',
  desc: 'Descubrí exactamente cuánto cobrar y cuánto ganar por cada budín. Sin cuentas a ojo.',
  value: '$8.990',
  icon: <Calculator className="w-6 h-6 text-burgundy-600" data-id="element-14" />,
  badgeColor: 'bg-gold-500 text-brown-900'
}, {
  badge: 'TOP 2',
  title: 'Kit de Diseño Profesional (Canva)',
  desc: 'Plantillas editables de historias, flyers, promos y menú listas para publicar. Aunque no sepas diseñar.',
  value: '$7.990',
  icon: <Palette className="w-6 h-6 text-burgundy-600" data-id="element-15" />,
  badgeColor: 'bg-cream-200 text-brown-900'
}, {
  badge: 'TOP 3',
  title: '50 Mensajes que Generan Pedidos',
  desc: 'Copiá, pegá y empezá a vender hoy por WhatsApp e Instagram. Adiós a la vergüenza.',
  value: '$5.990',
  icon: <MessageCircle className="w-6 h-6 text-burgundy-600" data-id="element-16" />,
  badgeColor: 'bg-burgundy-500 text-white'
}];
export function Bonuses() {
  return <section className="py-20 bg-brown-900 relative overflow-hidden" data-id="element-17">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-18">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-gold-500 rounded-full blur-3xl" data-id="element-19"></div>
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black/50 to-transparent" data-id="element-20"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl relative z-10" data-id="element-21">
        <div className="text-center mb-12" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-burgundy-600 text-white px-5 py-2 rounded-full font-bold text-base mb-6 shadow-glow" data-id="element-23">
            <Gift className="w-4 h-4" data-id="element-24" />
            🎁 BONOS GRATIS POR HOY
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-bold text-cream-50 mb-4" data-id="element-25">
            Te llevas también{' '}
            <span className="text-gold-400" data-id="element-26">3 bonos exclusivos</span>
          </motion.h2>

          <p className="text-base text-cream-200/80 max-w-xl mx-auto" data-id="element-27">
            Herramientas listas para acelerar tus resultados desde el día 1.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 mb-10" data-id="element-28">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/10 backdrop-blur-md border border-white/20 p-5 rounded-2xl relative" data-id="element-29">
              <div className={`absolute -top-3 left-5 ${bonus.badgeColor} px-3 py-0.5 rounded-full text-xs font-bold tracking-wide`} data-id="element-30">
                {bonus.badge}
              </div>

              <div className="bg-cream-100 w-11 h-11 rounded-xl flex items-center justify-center mb-3 mt-2" data-id="element-31">
                {bonus.icon}
              </div>

              <h3 className="font-bold text-cream-50 text-base mb-1.5 leading-snug" data-id="element-32">
                {bonus.title}
              </h3>
              <p className="text-cream-100/70 text-sm mb-3 leading-relaxed" data-id="element-33">
                {bonus.desc}
              </p>

              <div className="flex items-center gap-2 text-xs font-medium pt-3 border-t border-white/10" data-id="element-34">
                <span className="text-cream-100/50 line-through" data-id="element-35">
                  Valor: {bonus.value}
                </span>
                <span className="bg-gold-500 text-brown-900 px-2 py-0.5 rounded text-[10px] font-bold" data-id="element-36">
                  GRATIS HOY
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-burgundy-700/50 border border-burgundy-500/30 rounded-2xl p-5 text-center max-w-2xl mx-auto" data-id="element-37">
          <p className="text-cream-100 text-base" data-id="element-38">
            Valor total de los bonos:{' '}
            <span className="line-through opacity-70" data-id="element-39">$22.970</span>
          </p>
          <p className="text-xl font-bold text-gold-400 mt-1" data-id="element-40">
            ¡Hoy te los llevas 100% GRATIS con tu compra!
          </p>
        </motion.div>
      </div>
    </section>;
}